import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseSearch,
  baseGetWithoutParam,
  basePostArray,
  baseGet
} from 'services/base-services/baseService';
const baseURL = `${API2_HOST}/suppliers`;

const importSupplier = async request => {
  return await basePostArray(baseURL, request);
};

const getSupplierDetails = async id => {
  const res = await baseGet(`${baseURL}`, id);
  return res;
};

const getWDSuppliers = async () => {
  const res = await baseGetWithoutParam(`${baseURL}/source-wd`);
  return res.data;
};

const getEVASuppliers = async () => {
  const res = await baseGetWithoutParam(`${baseURL}/source-eva`);
  return res.data;
};

const searchSuppliers = async request => {
  const res = await baseSearch(baseURL, request);
  return res;
};

export {
  getEVASuppliers,
  getSupplierDetails,
  getWDSuppliers,
  searchSuppliers,
  importSupplier
};
